import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Scenario } from '@app/features/scope-overview/model/scenario.model'
import { environment } from '@envs/environment'
import { plainToInstance } from 'class-transformer'
import { map, Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class ScenarioService {
  private readonly BASE_URL: string = environment.scopeApiUrl + 'scenarios'

  constructor(private http: HttpClient) {}

  create(scenarioRequest: any): Observable<any> {
    return this.http
      .post(`${this.BASE_URL}`, scenarioRequest)
      .pipe(map((scenario) => plainToInstance(Scenario, scenario)))
  }

  getAll(includeCategories = false): Observable<Scenario[]> {
    return this.http
      .get<Scenario[]>(`${this.BASE_URL}?includeCategories=${includeCategories}`)
      .pipe(map((scenario) => plainToInstance(Scenario, scenario)))
  }

  get(id: number): Observable<Scenario> {
    return this.http
      .get<Scenario>(`${this.BASE_URL}/${id}`)
      .pipe(map((scenario) => plainToInstance(Scenario, scenario)))
  }

  update(id: number, scenarioRequest: any): Observable<void> {
    return this.http.put<void>(`${this.BASE_URL}/${id}`, scenarioRequest)
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.BASE_URL}/${id}`)
  }

  duplicate(id: number): Observable<string> {
    return this.http.post<string>(`${this.BASE_URL}/${id}/duplicate`, null)
  }

  export(id: number, scenarioName: string): Observable<any> {
    return this.http.post<void>(`${environment.scopeApiUrl}/company/scenario/export/${id}`, null, {
      params: { scenarioName },
    })
  }

  import(file: File) {
    const formData = new FormData()
    formData.append('file', file)
    return this.http.post(`${environment.scopeApiUrl}imports/scenarios`, formData)
  }

  getImportValidationFile(importUuid: string): Observable<any> {
    return this.http.get(`${environment.scopeApiUrl}downloads/${importUuid}`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    })
  }
}
